import { default as RedPlatformIcon } from './red-icon.svg';
import { default as TgPlatformIcon } from './tg-icon.svg';
import { default as TwitchPlatformIcon } from './twitch-icon.svg';
import { default as YtPlatformIcon } from './yt-icon.svg';

export { RedPlatformIcon, TgPlatformIcon, TwitchPlatformIcon, YtPlatformIcon };
